import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import dates, { DEFAULT_HOTEL_ONLY_DURATION } from 'utils/dates';
import { isCurrencyEur, dayInMilliseconds } from 'utils/utils';
import calendarUtils from 'utils/calendar';

import CalendarMonthSelect from 'components/CalendarMonthSelect/CalendarMonthSelect';
import PandaCalendar from 'components/PandaCalendar/PandaCalendar';

import './DatePickerWithPrices.scss';

export default class DatePickerWithPrices extends Component {
  static propTypes = {
    annualAvailability: ImmutablePropTypes.map.isRequired,
    annualAvailabilityType: PropTypes.oneOf(['ho', 'dp']),
    appState: ImmutablePropTypes.map.isRequired,
    baseState: ImmutablePropTypes.map.isRequired,
    displayPerNightPricing: PropTypes.bool,
    featureFlags: ImmutablePropTypes.map.isRequired,
    handleDayClick: PropTypes.func.isRequired,
    handleMonthClick: PropTypes.func.isRequired,
    numberOfChargeablePassengers: PropTypes.number.isRequired,
  };

  static defaultProps = {
    annualAvailabilityType: 'ho',
    displayPerNightPricing: false,
  };

  render() {
    const {
      annualAvailability,
      annualAvailabilityType,
      appState,
      baseState,
      featureFlags,
      handleDayClick,
      handleMonthClick,
      numberOfChargeablePassengers,
    } = this.props;

    const availability = annualAvailability.get(annualAvailabilityType, Immutable.Map());
    const availabilityExists = !!availability.size;
    const calDate = calendarUtils.getDepartureDate(baseState, true);
    const duration = Number(baseState.getIn(['queryState', 'props', 'duration', 'value'], DEFAULT_HOTEL_ONLY_DURATION));
    const isAppStateLoading = appState.get('loadingState');
    const selectedMonth = dates.format(calDate * dayInMilliseconds, 'MMMM');

    return (
      <div className="date-picker-with-prices">
        <div className="date-picker-with-prices__month-picker">
          <CalendarMonthSelect
            annualAvailability={annualAvailability}
            availabilityType="ho"
            baseState={baseState}
            onClickDate={handleMonthClick}
            disabled={!availabilityExists}
          />
        </div>
        <div className="date-picker-with-prices__date-picker">
          <PandaCalendar
            annualAvailability={availability}
            appState={appState}
            baseState={baseState}
            disableFooter
            disableHeader
            disableIcons
            featureFlags={featureFlags}
            noResults={!isAppStateLoading && !availabilityExists}
            numberOfChargeablePassengers={numberOfChargeablePassengers}
            numberOfNights={duration}
            offer={appState.get('selectedOffer')}
            onClickDate={handleDayClick}
            onlyHighlightSelectedDate
          />
        </div>
        <div className="date-picker-with-prices__key">
          <p className="date-picker-with-prices__key__items">
            <span className="date-picker-with-prices__key__item date-picker-with-prices__key__item--selected">
              Selected Date
            </span>
            <span className="date-picker-with-prices__key__item date-picker-with-prices__key__item--cheapest">
              Cheapest in {selectedMonth}
            </span>
          </p>
          <span className="date-picker-with-prices__key__text">
            {`${isCurrencyEur() ? '€' : '£'} Price shown is per person for ${duration} night${duration > 1 ? 's' : ''}`}
          </span>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/DatePickerWithPrices/DatePickerWithPrices.jsx
 **/